// TODO(RA-5904): a near future re-enable like RA-5740 + RA5806
// import { useDispatch } from 'react-redux';
import { IconButton } from '@material-ui/core';

// TODO(RA-5904): a near future re-enable like RA-5740 + RA5806
// import appAction from 'redux/actions/app-actions';

import { SUPPORTED_LANG } from 'intl/intl';
import SpainFlag from 'assets/images/flags/es.svg';
import BrazilFlag from 'assets/images/flags/br.svg';
import { WEB_PLATFORM_VERSION } from 'shared/infra/constants';

import makeClasses from './LanguageSelector.style';

export function LanguageSelector() {
  // const reduxDispatch = useDispatch();

  const _classes = makeClasses();

  // TODO(RA-5904): middle revert before of RA-5740 +++ +++
  const handleClickLanguage = lang => {
    localStorage.setItem('language', lang);
    window.location.reload();
  };
  // TODO(RA-5904): middle revert before of RA-5740 --- ---

  const handleSelectLangSpanish = () => {
    // TODO(RA-5904): a near future re-enable like RA-5740 + RA5806
    // reduxDispatch(appAction.setLanguageAction(SUPPORTED_LANG.es));
    // TODO(RA-5904): middle revert before of RA-5740
    handleClickLanguage(SUPPORTED_LANG.es);
  };

  const handleSelectLangPortuguese = () => {
    // TODO(RA-5904): a near future re-enable like RA-5740 + RA5806
    // reduxDispatch(appAction.setLanguageAction(SUPPORTED_LANG.pt));
    // TODO(RA-5904): middle revert before of RA-5740
    handleClickLanguage(SUPPORTED_LANG.pt);
  };

  return (
    <aside className={_classes.selector}>
      <div>
        <IconButton
          aria-label='select spanish'
          classes={{ root: _classes.btn }}
          onClick={handleSelectLangSpanish}
        >
          <img
            src={SpainFlag}
            alt={SUPPORTED_LANG.es}
            className={_classes.icon}
          />
        </IconButton>
        <IconButton
          aria-label='select portuguese'
          classes={{ root: _classes.btn }}
          onClick={handleSelectLangPortuguese}
        >
          <img
            src={BrazilFlag}
            alt={SUPPORTED_LANG.pt}
            className={_classes.icon}
          />
        </IconButton>
      </div>
      <p className={_classes.version}>V {WEB_PLATFORM_VERSION}</p>
    </aside>
  );
}
